<a [tdWbFocus]="true"
   tdWbFocusPosition="top"
   class="td-wb-focus-anchor"
   tabindex="-1">
</a>
